import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { GuestSmartTips } from '../../../accounts/modules/guestSmartTips/components/guestSmartTips';

interface SmartTipsProps {
    itemId: string;
}

export const SmartTips = ({ itemId }: SmartTipsProps) => {
    const gxGuestAiSmartTipsGuestProfilePage = useFeatureFlag(FeatureFlag.gxGuestAiSmartTipsGuestProfilePage);

    return <GuestSmartTips guestId={itemId} useAssistantApi={!gxGuestAiSmartTipsGuestProfilePage} />;
};
